import { SearchPanel } from '../search/SearchPanel';
import { Page } from '../ui';
import { XViewPanel } from '../xview/XViewPanel';

/**
 * 요청 메뉴 (22-B회차, 2026-09-08 사용자 확정 5).
 *
 * 위는 최근 5분 분포도(X-View), 아래는 기간 검색이다. 둘 다 "끝난 요청을 찾는 화면"인데
 * 탭이 따로 있어 방금 본 점을 어제 것과 견주려면 화면을 오가야 했다. 한 화면에 둔다.
 * 점을 누르든 결과 행을 누르든 상세로 가고, 상세의 돌아가기는 "요청으로"다.
 *
 * **조건 주인이 둘이다** (23-A회차 리뷰 3). 주소 하나에 분포도의 `x…` 키와 검색의 키가 같이
 * 실리고, 양쪽 다 `mergeQuery`로 제 키만 갈아 끼운다. 그래야 새로고침·공유·상세 왕복에서
 * 둘 다 살아남는다.
 */
export function RequestsPage({ query }: { query?: string }) {
  return (
    <Page>
      <XViewPanel query={query} />
      <SearchPanel query={query} />
    </Page>
  );
}
